import { IKycData } from '../../interfaces/i-api-kyc'
import { useTranslation } from 'react-i18next'

export const PepInformationFormDE_NO = (data: IKycData) => {
	const { t } = useTranslation(['translation', 'forms'])

	return {
		fieldSetName: t('forms:PEPInfoHeader'),
		formName: data.customerType,
		description: t('forms:PEPInfoDescription'),
		show: true,
		visible: true,
		col: 12,
		controls: [
			{
				options: [
					{
						value: 'false',
						label: t('No'),
					},
					{
						value: 'true',
						label: t('Yes'),
					},
				],
				controlName: 'politicallyExposedPerson',
				type: 'checkbox',
				label: t('forms:PoliticallyExposedPerson'),
				value: data.politicallyExposedPerson,
				col: 12,
				visible: true,
			},
			{
				options: [
					{
						value: 'false',
						label: t('No'),
					},
					{
						value: 'true',
						label: t('Yes'),
					},
				],
				controlName: 'connectedToPep',
				type: 'checkbox',
				label: t('forms:ConnectedToPep'),
				col: 12,
				value: data.connectedToPep,
				visible: true,
			},
		],
	}
}
